export const messages = {
  en: {
    shopVipUser: {
      title: 'Shop VIP User Management',
      queryCondition: 'Query Conditions',
      vipName: 'VIP Name',
      vipTel: 'VIP Phone',
      query: 'Query',
      reset: 'Reset',
      vipInfo: 'VIP Information',
      addVip: 'Add VIP',
      export: 'Export',
      vipId: 'VIP ID',
      vipLevel: 'VIP Level',
      sex: 'Gender',
      male: 'Male',
      female: 'Female',
      birthday: 'Birthday',
      startTime: 'Start Time',
      endTime: 'End Time',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      detail: 'Detail',
      confirmDelete: 'Confirm Delete',
      deleteConfirmText: 'Are you sure to delete this VIP user?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      addTitle: 'Add VIP User',
      editTitle: 'Edit VIP User',
      required: 'Required',
      save: 'Save',
      success: 'Success',
      addSuccess: 'Add success',
      editSuccess: 'Edit success',
      deleteSuccess: 'Delete success',
      exportSuccess: 'Export success'
    }
  },
  zh: {
    shopVipUser: {
      title: '店铺会员管理',
      queryCondition: '查询条件',
      vipName: '会员名称',
      vipTel: '会员电话',
      query: '查询',
      reset: '重置',
      vipInfo: '会员信息',
      addVip: '添加会员',
      export: '导出',
      vipId: '会员编号',
      vipLevel: '会员等级',
      sex: '性别',
      male: '男',
      female: '女',
      birthday: '会员生日',
      startTime: '开始时间',
      endTime: '结束时间',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      detail: '详情',
      confirmDelete: '确认删除',
      deleteConfirmText: '确定删除会员信息吗？',
      cancel: '取消',
      confirm: '确认',
      addTitle: '添加会员',
      editTitle: '修改会员',
      required: '必填',
      save: '保存',
      success: '成功',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功',
      exportSuccess: '导出成功'
    }
  }
}